import React, { useState } from "react";
import { X } from "lucide-react";

const inputCls =
  "w-full border border-[#e2e1eb] rounded-md px-2.5 py-1.5 text-[13px] focus:outline-none focus:border-yamaha-400";

const FOLLOWUP_MODES = [
  ["call", "Call"],
  ["whatsapp", "WhatsApp"],
  ["walk_in", "Walk-In"],
  ["other", "Other"],
];

/** Phase 2 — simple follow-up log (Call / WhatsApp / Walk-In / Other).
 *  Appends directly to the existing LOC Activity Timeline — no separate
 *  response-tracking table, no stage/status change. */
export const LocFollowupDialog = ({ onClose, onSubmit }) => {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [mode, setMode] = useState("call");
  const [remarks, setRemarks] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await onSubmit({ date, mode, remarks });
      onClose();
    } catch (e) {
      // Error toast already shown by the caller; keep the dialog open to retry.
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" data-testid="loc-followup-modal">
      <div className="bg-white rounded-xl border border-[#e2e1eb] w-full max-w-sm shadow-xl">
        <div className="px-5 py-3 border-b border-[#e2e1eb] flex items-center justify-between">
          <h3 className="text-[14px] font-semibold text-[#1a1b22]">Add Follow-up</h3>
          <button onClick={onClose}><X className="w-4 h-4 text-[#747684]" /></button>
        </div>
        <div className="p-5 space-y-3">
          <div>
            <label className="text-[11px] font-semibold uppercase tracking-wider text-[#747684] block mb-1">Date</label>
            <input type="date" data-testid="loc-followup-date" value={date} onChange={(e) => setDate(e.target.value)} className={inputCls} />
          </div>
          <div>
            <label className="text-[11px] font-semibold uppercase tracking-wider text-[#747684] block mb-1">Mode</label>
            <select data-testid="loc-followup-mode" value={mode} onChange={(e) => setMode(e.target.value)} className={inputCls}>
              {FOLLOWUP_MODES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
          <div>
            <label className="text-[11px] font-semibold uppercase tracking-wider text-[#747684] block mb-1">Remarks</label>
            <textarea data-testid="loc-followup-remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} rows={3} className={inputCls} />
          </div>
        </div>
        <div className="px-5 py-3 border-t border-[#e2e1eb] flex justify-end gap-2 bg-[#fafafd] rounded-b-xl">
          <button onClick={onClose} className="px-3 py-1.5 rounded-md text-[13px] font-medium text-[#444653] hover:bg-[#f0eff7]">Cancel</button>
          <button onClick={submit} disabled={saving} data-testid="loc-followup-submit-btn"
            className="px-4 py-1.5 rounded-md text-[13px] font-semibold text-white bg-yamaha-700 hover:bg-yamaha-800 disabled:opacity-60">
            {saving ? "Saving…" : "Add Follow-up"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocFollowupDialog;
